/**
 * GSAP PixiPlugin registration — must be imported once at app startup
 * to enable GSAP animations targeting PixiJS display objects.
 */
import gsap from 'gsap';
import { PixiPlugin } from 'gsap/PixiPlugin';
import * as PIXI from 'pixi.js';

gsap.registerPlugin(PixiPlugin);
PixiPlugin.registerPIXI(PIXI);
